import { Link } from "react-router-dom";
import PropertyCard from "../PropertyCard";
import { Building2, Send, CreditCard, AlertTriangle, Heart } from "lucide-react";

function Empty({ icon, label, cta, link }) {
  return (
    <div className="brut-card p-8 col-span-full text-center">
      {icon}
      <div className="font-display font-black text-2xl mt-2">{label}</div>
      {cta && link && <Link to={link} className="brut-btn mt-4 inline-flex">{cta}</Link>}
    </div>
  );
}

export function ListingsTab({ myProps }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="my-listings">
      {myProps.length === 0
        ? <Empty icon={<Building2 size={32} className="mx-auto"/>} label="No listings yet" cta="Add your first PG" link="/list-property"/>
        : myProps.map(p => (
          <div key={p.id} className="relative">
            <PropertyCard p={p}/>
            <span className={`absolute top-3 right-3 brut-tag ${p.status==="active"||p.status==="approved"?"lime":"pink"}`}>{p.status}</span>
          </div>
        ))}
    </div>
  );
}

export function EnquiriesTab({ enquiries, user, updateEnquiryStatus }) {
  return (
    <div className="space-y-3" data-testid="enquiries-list">
      {enquiries.length === 0
        ? <Empty icon={<Send size={32} className="mx-auto"/>} label="No enquiries yet"/>
        : enquiries.map(e => (
          <div key={e.id} className="brut-card p-5" data-testid={`enquiry-${e.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-display font-black text-xl">{e.property_title}</div>
                <div className="text-sm text-[#4A4A4A] mt-1">
                  {user.role === "owner" ? `From: ${e.student_name} • ${e.student_email}` : `Sent on ${new Date(e.created_at).toLocaleDateString()}`}
                </div>
              </div>
              <span className={`brut-tag ${e.status === "pending" ? "white" : e.status === "accepted" ? "lime" : "pink"}`}>{e.status}</span>
            </div>
            <p className="mt-3 text-[#2a2a2a]">{e.message}</p>
            {e.move_in_date && <p className="text-sm mt-1"><strong>Move-in:</strong> {e.move_in_date}</p>}
            {user.role === "owner" && e.status === "pending" && (
              <div className="flex gap-2 mt-3">
                <button className="brut-btn" onClick={()=>updateEnquiryStatus(e.id, "accepted")} data-testid={`accept-${e.id}`}>Accept</button>
                <button className="brut-btn pink" onClick={()=>updateEnquiryStatus(e.id, "rejected")} data-testid={`reject-${e.id}`}>Reject</button>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

export function PaymentsTab({ payments }) {
  return (
    <div className="space-y-3" data-testid="payments-list">
      {payments.length === 0
        ? <Empty icon={<CreditCard size={32} className="mx-auto"/>} label="No payments yet"/>
        : payments.map(p => (
          <div key={p.session_id} className="brut-card p-4 flex flex-wrap gap-3 items-center">
            <div className="flex-1 min-w-[200px]">
              <div className="font-bold">₹{p.amount_inr?.toLocaleString()}</div>
              <div className="text-xs text-[#4A4A4A]">{p.created_at?.slice(0,10)} · session {p.session_id?.slice(-8)}</div>
            </div>
            <span className={`brut-tag ${p.payment_status==="paid"?"lime":"pink"}`}>{p.payment_status}</span>
          </div>
        ))}
    </div>
  );
}

export function ComplaintsTab({ complaints }) {
  return (
    <div className="space-y-3" data-testid="complaints-list">
      {complaints.length === 0
        ? <Empty icon={<AlertTriangle size={32} className="mx-auto"/>} label="No complaints — yay!"/>
        : complaints.map(c => (
          <div key={c.id} className="brut-card p-5">
            <div className="flex justify-between flex-wrap gap-2">
              <strong>{c.subject}</strong>
              <div className="flex gap-1">
                <span className={`brut-tag ${c.priority==="high"?"pink":"white"} !text-[10px]`}>{c.priority}</span>
                <span className={`brut-tag ${c.status==="open"?"pink":"lime"} !text-[10px]`}>{c.status}</span>
              </div>
            </div>
            {c.property_title && <div className="text-xs text-[#4A4A4A] mt-1">{c.property_title}</div>}
            <p className="mt-2 text-sm">{c.description}</p>
          </div>
        ))}
    </div>
  );
}

export function SavedTab({ saved }) {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="saved-grid">
      {saved.length === 0
        ? <Empty icon={<Heart size={32} className="mx-auto"/>} label="No saved PGs" cta="Browse PGs" link="/properties"/>
        : saved.map(p => <PropertyCard key={p.id} p={p}/>)}
    </div>
  );
}
